import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Indeterminate Checkbox Design Guidelines",
  "title": "Indeterminate Checkbox",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="indeterminate_checkbox" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Commonly used in hierarchical checkboxes to indicate that only some of the
  checkbox's descendants are checked.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`Use the indeterminate state when the checkbox contains a sub list of selections, some of which are selected, and some unselected.`}</p>
      <p>{`View the `}<Link to="/design/checkboxes/" mdxType="Link">{`documentation for checkboxes`}</Link>{` for more details.`}</p>
      <span {...{
        "className": "horizontal-spacer"
      }}>
        <figure parentName="span">{`
  `}<div parentName="figure" {...{
            "className": "image-container"
          }}>{`
    `}<span parentName="div" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "600px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "64.09266409266408%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA+UlEQVQ4y6VSwYrCMBD1Z/e4f+Vhb3vYiyAou/6CCqaNFpYmlpZiWkxJm+YtzW5A61oaHRiSMDMv783MBP+YMQZD5uIXpyswk3vJUjbgx7N9t20LrfUV0OWng4Ba/8YWnzFeXlc4nQQoDREEAQghYIzdgI5iKAqFfVRcFTu2/bYMAvaTOefIsgxSSpRliaqqHmHo2BiEYYhDFCGOY3tPksQP8JZl++f3VYyS3LHrbPoWYDb/RlnkYIxbhk3TjF+bPuD7xwHLLwalzlZ2N2WllB/gmAX3luxy1pstdoRYdpRSOxghhL9kl5OmKfI8R13XdmU69+7hM5J/AL9i/Ov0+/VTAAAAAElFTkSuQmCC')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "",
                "title": "",
                "src": "/static/750aed54bc4af80d31d75ae8fd933e85/0a47e/Checkbox-parent-child-example.png",
                "srcSet": ["/static/750aed54bc4af80d31d75ae8fd933e85/a2ead/Checkbox-parent-child-example.png 259w", "/static/750aed54bc4af80d31d75ae8fd933e85/6b9fd/Checkbox-parent-child-example.png 518w", "/static/750aed54bc4af80d31d75ae8fd933e85/0a47e/Checkbox-parent-child-example.png 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Parent-child relationship for checkboxes`}</p>{`
  `}</figcaption>
        </figure></span>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      